import React, {useState, useEffect, createRef} from 'react';
import {
    Routes,
    Route
} from 'react-router-dom';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './style/custom-layout.scss';
import './style/custom-openlayers.scss';

import {useTranslation} from 'react-i18next';

import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import {ConfirmDialog} from 'primereact/confirmdialog';
import {KeycloakService} from './services/KeycloakService';

import {NotFound} from './views/pages/NotFound';
import Main from './views/Main';
import {updateToastRef} from '@dmt/global_npm';
import {ProgressSpinner} from 'primereact/progressspinner';
import {hideWaitAnimation, showWaitAnimation, updateWaitAnimationRef} from '@dmt/global_npm';
import store from './redux/store';
import settings from './config/settings';

const keycloakDisabled = process.env.REACT_APP_DISABLE_KEYCLOAK === 'true';

const App = () => {

    const {t} = useTranslation(['common']);

    const [confirmDialogVisible, setConfirmDialogVisible] = useState<boolean>(false);
    const [keycloakToken, setKeycloakToken] = useState<string>(keycloakDisabled ? 'no-keycloak' : '');
    const toast: any = createRef();
    const waitAnimation: any = createRef();

    useEffect(() => {
        updateToastRef(toast);
    });

    useEffect(() => {
        updateWaitAnimationRef(waitAnimation);
    });

    const logout = () => {
        showWaitAnimation();
        const currentUrl = window.location.href;
        const state = store.getState();
        const keycloakIdToken = state.keycloakData.keycloak.keycloakIdToken;
        window.location.href = settings.logoutUrl
            + '?id_token_hint=' + keycloakIdToken
            + '&post_logout_redirect_uri=' + currentUrl;
        hideWaitAnimation();
    };

    const onSessionExpired = () => {
        setConfirmDialogVisible(true);
    };

    const sessionExpiredDialogFooter = (
        <React.Fragment>
            <Button label={'Ok'} icon="pi pi-check" className="p-button-text" onClick={logout}/>
        </React.Fragment>
    );

    return (
        <>
            {keycloakToken && <Routes>
                <Route path={'/'} element={<Main/>}/>
                <Route path={'/:projectId'} element={<Main/>}/>
                <Route path={'/project/:projectId'} element={<Main/>}/>
                <Route path='*' element={<NotFound/>}/>
            </Routes>}
            {!keycloakDisabled && <KeycloakService onAuth={setKeycloakToken} onSessionExpired={onSessionExpired}/>}
            <ConfirmDialog
                className={'hide-x'}
                visible={confirmDialogVisible}
                message={t('sessionExpired_message')}
                header={t('sessionExpired_header')}
                icon="pi pi-exclamation-triangle"
                footer={sessionExpiredDialogFooter}
            />
            <Toast ref={toast}/>
            {<div ref={waitAnimation}
                  style={{
                      position: 'absolute',
                      height: '100%',
                      width: '100%',
                      zIndex: '9999999',
                      display: 'none',
                      top: 'calc(50% - 50px)',
                      left: 'calc(50% - 50px)'
                  }}>
                <ProgressSpinner style={{width: '100px', height: '100px'}} strokeWidth={'5px'}/></div>}
        </>
    );
};

export default App;
